<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer">
          <div slot="header">
            <strong>Plan Upload</strong>
            <div class="card-header-actions"></div>
          </div>
          <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
            <b-row class="mt-2 mb-2">
              <b-col md="6">
                <b-row>
                  <b-col sm="4" class="pr-0">
                    <label><b>Plan Type</b></label>&nbsp;<span style="color: red;">*</span>
                  </b-col>
                  <b-col sm="8" class="pl-0">
                    <b-form-group>
                      <select v-model="planUploadedType" class="form-control"  name="plan type" v-validate="'required'"
                      :class="{
                        input: true,
                        'is-invalid': errors.has('form-1.plan type'),
                      }">
                        <option v-for="option in options" v-bind:key="options" :value="option.value">
                          {{ option.text }}
                        </option>
                      </select>
                      <span v-show="errors.has('form-1.plan type')"
                      class="help text-danger"
                      >{{ errors.first("form-1.plan type") }}</span>
                    </b-form-group>
                  </b-col>

                  <b-col sm="4" class="pr-0">
                    <label><b>Enter Vehicle No.</b></label>&nbsp;<span style="color: red">*</span>
                  </b-col>
                  <b-col sm="8" class="pl-0">
                    <b-form-group>
                      <v-select v-model="selected_vehicleno" :options="vehiclenumber" placeholder="-- Select Vehicle NO --" name="vehicle number" v-validate="'required'"
                        :class="{
                          input: true,
                          'is-invalid': errors.has('form-1.vehicle number'),
                        }">
                      <span slot="no-options" @click="$refs.select.open = false"> Stating Vehicle not found please register it first </span>
                      </v-select>
                      <span v-show="errors.has('form-1.vehicle number')"
                        class="help text-danger"
                        >{{ errors.first("form-1.vehicle number") }}</span>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
              <b-col md="6">
                <div id="showUploadCsvField" v-if="planUploadedType != null" class="mb-3">
                  <a :href="csvUrlvar + planUploadedType" download>
                    <button class="btn btn-primary" v-on:click="downloadplanedcsv()" type="button"> Download Sample CSV </button>
                  </a>
                </div> 
                <b-row>
                  <b-col sm="3" class="pr-0">
                    <label><b>Choose File</b></label>&nbsp;<span style="color: red;">*</span>
                  </b-col>
                  <b-col sm="7" class="pl-0">
                    <b-form-group>
                      <b-form-file col="2" type="file" v-model="file" :state="Boolean(file)" @change="selectcsvFiletoUpload($event)" placeholder="Upload CSV File" accept=".csv" required></b-form-file>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
              <b-col md="6">
                <b-button size="md" variant="primary" type="submit" :disabled="isReadOnly">
                  <i class="fa fa-dot-circle-o"></i>&nbsp;Submit
                </b-button> &nbsp; 
                <b-button @click="clearSearch()" size="md" variant="danger">
                  <i class="fa fa-ban"></i>&nbsp;Reset
                </b-button>
              </b-col>
            </b-row>
          </b-form>
          <hr />
          <hr />
          <div>
            <b-row class="mt-5">
              <b-col sm="3">
                <b-col sm="12">
                  <b-form-group label="From Date:" :label-cols="3">
                    <v-date-picker
                      mode="single"
                      input-class="dateInput"
                      :available-dates="{ start: null, end: new Date() }"
                      v-model="selectDateFrom"
                    >
                    </v-date-picker>
                  </b-form-group>
                </b-col>
              </b-col>
              <b-col sm="3">
                <b-form-group label="To Date:" :label-cols="3">
                  <v-date-picker
                    mode="single"
                    input-class="dateInput"
                    :available-dates="{ start: null, end: new Date() }"
                    v-model="selectDateTo"
                  >
                  </v-date-picker>
                </b-form-group>
              </b-col>

              <b-col sm="4">
                <b-form-group label="Vahicle No." :label-cols="3">
                  <v-select
                    v-model="selected_vehicleno"
                    @input="selectsearchvehicle(selected_vehicleno)"
                    :options="vehiclenumber"
                    placeholder="-- Select Vehicle NO --"
                  >
                    <span slot="no-options" @click="$refs.select.open = false">
                      Stating Vehicle not found please register it first
                    </span>
                  </v-select>
                </b-form-group>
              </b-col>
              <b-col sm="2">
                <b-button size="md" variant="primary" @click="searchPlan()"
                  ><i class="fa fa-search"></i>&nbsp;Search</b-button
                >
              </b-col>
            </b-row>
          </div>
          <b-col sm="12">
            <b-table
              responsive
              show-empty
              :busy="isBusy"
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              :sort-direction="sortDirection"
            >
              <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>

              <template slot="hub_name" slot-scope="row">
                <p v-if="row.item.hubname == null || row.item.hubname == ''">
                  NA
                </p>
                <p v-if="row.item.hubname != null || row.item.hubname != ''">
                  {{ row.item.hubname }}
                </p>
              </template>
              <template slot="planedited_date" slot-scope="row">
                <p
                  v-if="
                    row.item.plan_edited_date == null ||
                      row.item.plan_edited_date == ''
                  "
                >
                  NA
                </p>
                <p
                  v-if="
                    row.item.plan_edited_date != null ||
                      row.item.plan_edited_date != ''
                  "
                >
                  {{ row.item.plan_edited_date }}
                </p>
              </template>
              <template slot="planeditedby" slot-scope="row">
                <p
                  v-if="
                    row.item.plan_editedby == null ||
                      row.item.plan_editedby == ''
                  "
                >
                  NA
                </p>
                <p
                  v-if="
                    row.item.plan_editedby != null ||
                      row.item.plan_editedby != ''
                  "
                >
                  {{ row.item.plan_editedby }}
                </p>
              </template>
              <template slot="download" slot-scope="row">
                <a><i class="fa fa-download"></i></a>
              </template>
              <template slot="view" slot-scope="row">
                <router-link v-if="!isReadOnly" :to="'/viewPlanDetails/' + row.item.plan_id +','+ row.item.plan_type" :disabled="isReadOnly">
                  <a :href="row.item.file_path" target="blank">
                    <i class="fa fa-eye"></i>
                  </a>
                </router-link>
              </template>
            </b-table>
          </b-col>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import auth from "@/utils/auth";

export default {
  data: function() {
    return {
      isBusy: false,
      planUploadedType: null,
      hub_name: "",
      selected_vehicleno: "",
      selectcsvFile: "",
      selectFiletype: "",
      file: "",
      selectDateFrom: new Date(),
      selectDateTo: new Date(),
      vehiclenumber: [],
      csvUrl: "",
      csvUrlvar: "",
      options: [
        { text: "-- Select Plan Type --", value: null },
        { text: "Hub Inward", value: "Hub Inward" },
        {
          text: "Hub Inward And Direct Dispatch Plan",
          value: "Hub Inward And Direct Dispatch Plan",
        },
        {
          text: "Direct Dispatch And Hub Inward Plan",
          value: "Direct Dispatch And Hub Inward Plan",
        },
        { text: "Hub Outward", value: "Hub Outward" },
        {
          text: "Hub Outward And Direct Dispatch Plan",
          value: "Hub Outward And Direct Dispatch Plan",
        },
        { text: "Direct Dispatch Plan", value: "Direct Dispatch Plan" },
        { text: "Client Pickup", value: "Client Pickup" },
      ],
      items: [],

     
      fields: [
        {
          key: "plan_id",
          label: "Sr. no",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "created_date",
          label: "Plan UPloaded Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "plan_type",
          label: "Plan Type",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "uploaded_by",
          label: "Plan Uploaded By",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "vehicleno",
          label: "Vehicle no.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "hub_name",
          label: "HUB",
          sortable: true,
          sortDirection: "desc",
        },

        {
          key: "loadcount",
          label: "Load Count",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "boxcount",
          label: "Box Count",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "planeditedby",
          label: "Plan Edited By",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "planedited_date",
          label: "Plan Edited on",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "download",
          label: "Download Ewaybill",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "view",
          label: "View/Edit",
          sortable: true,
          sortDirection: "desc",
        },
      ],
      accessBody:[],
      isReadOnly:false,
    };
  },

  created: function() {
    var userdata = localStorage.getItem("userData");
    var userInfo = JSON.parse(userdata);
    this.userType = userInfo.user_type;
    this.user_id = userInfo.sysusermasterid;
    this.accessBody = userInfo.body;
    this.ischeckbodyvalidation();
    this.getAllPlanListing();
    this.vehicleListing();
  },

  methods: {
    ischeckbodyvalidation(){
            for (let i = 0; i < this.accessBody.length; i++) {
                const element = this.accessBody[i];
            
                if (element.title=='Plan Upload' && element.isReadonly==true) {
                  this.isReadOnly=true
                }
            if (element.child) {
                for (let j = 0; j < element.child.length; j++) {
                const k = element.child[j];
                if (k.title=='Plan Upload' && k.isReadonly==true) {
                    this.isReadOnly=true
                }
                }
            }
            }
            console.log(" this.isReadOnly", this.isReadOnly)
        },
    vehicleListing() {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      let obj = {
        sysusermasterid: `${userInfo.sysusermasterid}`,
        usertype: "",
        isactive: "1",
        vehicle_type: "bulkreallocate",
      };
      console.log("obj", obj);

      this.$http
        .post(`${CONSTANTS.MISREPORT_API_URL}/getVehicleListing`, obj)
        .then((result) => {
          // console.log("result", result);
          // if (result.body.returnmsg === "Successful") {
          this.vehicleitems = result.body;
          console.log("vehicleitems", this.vehicleitems);
          for (let i = 0; i < this.vehicleitems.length; i++) {
            this.vehiclenumber.push(this.vehicleitems[i].vehicle_no);
          }
          // } else {
          //   this.vehicleitems = [];
          // }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },

    downloadplanedcsv() {
      console.log("this.planUploadedType",this.planUploadedType);
      // this.csvUrl =
      //   "http://65.2.154.47/api_ftl/getSampleCSVForPlanType?plan_type=";
      
      // this.csvUrlvar = this.csvUrl;


      this.csvUrl=`${CONSTANTS.MIGRATION_API_URL}/getSampleCSVForPlanType?plan_type=`
      this.csvUrlvar = this.csvUrl;
      console.log(this.csvUrlvar);
    },

    validateForm(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.uploadPalnDetails();
        }
      });
    },

    selectcsvFiletoUpload(event) {
      this.selectcsvFile = event.target.files[0];
      // this.imgname= this.selectedFiles.name;
      console.log("HHH", this.selectcsvFile);

      this.selectFiletype = event.target.files[0].type;
      console.log("selectFiletype", this.selectFiletype);
    },

    uploadPalnDetails: function() {
      document.getElementById("overlay").style.display = "block";
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      console.log("this.selected_vehicleno",this.selected_vehicleno)

      if (this.selected_vehicleno=="" || this.selected_vehicleno == null) {
          this.$fire({
          text: "Please Select Vehicle Number",
          type: "error",
          timer: 30000,
        });
        document.getElementById("overlay").style.display = "none";
        return false; 
      }

      if (this.selectFiletype == "text/csv") {
        let data = new FormData();
        data.append("file", this.selectcsvFile);
        data.append(
          "uploadedby",
          userInfo.userfirstname + " " + userInfo.userlastname
        );
        data.append("plan_type", this.planUploadedType);
        data.append("vehicleno", this.selected_vehicleno);
        let config = {
          header: {
            "Content-Type": "multipart/form-data",
          },
        };
        console.log("Config", config);
        // return false;
        if (this.planUploadedType=='Hub Inward') {
          this.$http.post(
            `${CONSTANTS.MIGRATION_API_URL}/uploadHubInwardPlan`,
            data,
            {
              header: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((result) => {
            console.log("YYY", result);
            document.getElementById("overlay").style.display = "none";
            this.resultMsg = result.body.returnmsg;
            if (result.body.returnmsg === "Successful") {
              // alert("inn");
              this.$fire({
                text: result.body.returnvalue,
                type: "success",
                timer: 30000,
              });

              this.selectcsvFile = "";
              this.selectFiletype = "";
              this.planUploadedType = "";
              this.hub_name = "";
              this.selected_vehicleno = "";
              this.getAllPlanListing();
            } else {
              this.$fire({
                text: result.body.returnvalue,
                type: "error",
                timer: 30000,
              });
            }
          })
          .catch((ex) => {
            console.log("error", ex);
          });
        }
        else if (this.planUploadedType=='Hub Outward') {
          this.$http.post(
            `${CONSTANTS.MIGRATION_API_URL}/uploadHubOutwardPlan`,
            data,
            {
              header: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((result) => {
            console.log("YYY", result);
            document.getElementById("overlay").style.display = "none";
            this.resultMsg = result.body.returnmsg;
            if (result.body.returnmsg === "Successful") {
              // alert("inn");
              this.$fire({
                text: result.body.returnvalue,
                type: "success",
                timer: 30000,
              });

              this.selectcsvFile = "";
              this.selectFiletype = "";
              this.planUploadedType = "";
              this.hub_name = "";
              this.selected_vehicleno = "";
              this.getAllPlanListing();
            } else {
              this.$fire({
                text: result.body.returnvalue,
                type: "error",
                timer: 30000,
              });
            }
          })
          .catch((ex) => {
            console.log("error", ex);
          });
        }
        else if (this.planUploadedType=='Hub Inward And Direct Dispatch Plan') {
          this.$http.post(
            `${CONSTANTS.MIGRATION_API_URL}/uploadHubInwardAndDirectDispatch`,
            data,
            {
              header: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((result) => {
            console.log("YYY", result);
            document.getElementById("overlay").style.display = "none";
            this.resultMsg = result.body.returnmsg;
            if (result.body.returnmsg === "Successful") {
              // alert("inn");
              this.$fire({
                text: result.body.returnvalue,
                type: "success",
                timer: 30000,
              });

              this.selectcsvFile = "";
              this.selectFiletype = "";
              this.planUploadedType = "";
              this.hub_name = "";
              this.selected_vehicleno = "";
              this.getAllPlanListing();
            } else {
              this.$fire({
                text: result.body.returnvalue,
                type: "error",
                timer: 30000,
              });
            }
          })
          .catch((ex) => {
            console.log("error", ex);
          });
        }
        else if (this.planUploadedType=='Hub Outward And Direct Dispatch Plan') {
          this.$http.post(
            `${CONSTANTS.MIGRATION_API_URL}/uploadHubOutwardAndDirectDispatchPlan`,
            data,
            {
              header: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((result) => {
            console.log("YYY", result);
            document.getElementById("overlay").style.display = "none";
            this.resultMsg = result.body.returnmsg;
            if (result.body.returnmsg === "Successful") {
              // alert("inn");
              this.$fire({
                text: result.body.returnvalue,
                type: "success",
                timer: 30000,
              });

              this.selectcsvFile = "";
              this.selectFiletype = "";
              this.planUploadedType = "";
              this.hub_name = "";
              this.selected_vehicleno = "";
              this.getAllPlanListing();
            } else {
              this.$fire({
                text: result.body.returnvalue,
                type: "error",
                timer: 30000,
              });
            }
          })
          .catch((ex) => {
            console.log("error", ex);
          });
        }
        else if (this.planUploadedType=='Direct Dispatch Plan') {
          this.$http.post(
            `${CONSTANTS.MIGRATION_API_URL}/uploadDirectDispatchPlan`,
            data,
            {
              header: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((result) => {
            console.log("YYY", result);
            document.getElementById("overlay").style.display = "none";
            this.resultMsg = result.body.returnmsg;
            if (result.body.returnmsg === "Successful") {
              // alert("inn");
              this.$fire({
                text: result.body.returnvalue,
                type: "success",
                timer: 30000,
              });

              this.selectcsvFile = "";
              this.selectFiletype = "";
              this.planUploadedType = "";
              this.hub_name = "";
              this.selected_vehicleno = "";
              this.getAllPlanListing();
            } else {
              this.$fire({
                text: result.body.returnvalue,
                type: "error",
                timer: 30000,
              });
            }
          })
          .catch((ex) => {
            console.log("error", ex);
          });
        }
        else if (this.planUploadedType=='Direct Dispatch And Hub Inward Plan') {
          this.$http.post(
            `${CONSTANTS.MIGRATION_API_URL}/uploadDirectDispatchAndHubInward`,
            data,
            {
              header: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((result) => {
            console.log("YYY", result);
            document.getElementById("overlay").style.display = "none";
            this.resultMsg = result.body.returnmsg;
            if (result.body.returnmsg === "Successful") {
              // alert("inn");
              this.$fire({
                text: result.body.returnvalue,
                type: "success",
                timer: 30000,
              });

              this.selectcsvFile = "";
              this.selectFiletype = "";
              this.planUploadedType = "";
              this.hub_name = "";
              this.selected_vehicleno = "";
              this.getAllPlanListing();
            } else {
              this.$fire({
                text: result.body.returnvalue,
                type: "error",
                timer: 30000,
              });
            }
          })
          .catch((ex) => {
            console.log("error", ex);
          });
        }
        else{
          document.getElementById("overlay").style.display = "none";
          this.$fire({
          text: "Please Check Plan Type",
          type: "error",
          timer: 30000,
        });
        }
      } else {
        document.getElementById("overlay").style.display = "none";
        this.$fire({
          text: "Please Upload CSV File Only",
          type: "error",
          timer: 30000,
        });
      }
    },

    clearSearch() {
      this.file=''
      this.planUploadedType = "";
      this.hub_name = "";
      this.selected_vehicleno = "";
    },

    formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },

    searchPlan: function() {
      var fromdate =
        this.selectDateFrom != null ? this.formatDate(this.selectDateFrom) : "";
      var formatdateto =
        this.selectDateTo != null ? this.formatDate(this.selectDateTo) : "";
      this.isBusy = true;
      const obj = {
        startdate: `${fromdate}`,
        enddate: `${formatdateto}`,
        vehicleno: this.selected_vehicleno,
      };

      if (formatdateto < fromdate) {
        this.$fire({
          text: "To date need to be grater than From date",
          type: "warning",
          timer: 30000,
        });
        this.isBusy = false;
        return false;
      }

      this.$http
        .post(`${CONSTANTS.MISREPORT_API_URL}/getAllPlanListing`, obj)
        .then((result) => {
          this.isBusy = false;
          if (result.body.returnmsg === "Successful") {
            this.items = result.body.returnvalue;
          } else {
            //  this.showdata = []
            this.items = [];
            // this.totalRows = 0;
          }
        })
        .catch((ex) => {
          console.log("error-----", ex);
        });
    },

    getAllPlanListing: function() {
      const obj = {
        startdate: "",
        enddate: "",
        vehicleno: "",
      };

      this.$http
        .post(`${CONSTANTS.MISREPORT_API_URL}/getAllPlanListing`, obj)
        .then((result) => {
          this.isBusy = false;
          if (result.body.returnmsg === "Successful") {
            this.items = result.body.returnvalue;
          } else {
            //  this.showdata = []
            this.items = [];
            // this.totalRows = 0;
          }
        })
        .catch((ex) => {
          console.log("error-----", ex);
        });
    },
  },
};
</script>
